import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMixer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 100,
	viewBox: "0 0 80.0 100.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 80.0 0.0 L 80.0 60.0 A 40.0 40.0 0.0 1 1 0.0 60.0 L 0.0 0.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 43.09 60.64 A 15.0 3.0 90.13 0 1 40.06 75.63 A 15.0 3.0 90.13 0 1 37.09 60.63 A 15.0 3.0 90.13 0 1 40.13 45.63 A 15.0 3.0 90.13 0 1 43.09 60.64 Z M 53.6 37.94 A 15.0 3.0 139.61 0 1 40.23 45.38 A 15.0 3.0 139.61 0 1 49.71 33.38 A 15.0 3.0 139.61 0 1 63.08 25.94 A 15.0 3.0 139.61 0 1 53.6 37.94 Z M 30.42 33.32 A 15.0 3.0 40.22 0 1 39.94 45.29 A 15.0 3.0 40.22 0 1 26.55 37.9 A 15.0 3.0 40.22 0 1 17.03 25.92 A 15.0 3.0 40.22 0 1 30.42 33.32 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgMixer;
